var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftOrnament2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.244,
    height: 930.047,
    viewBox: "0 0 135.244 930.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_61",
    "data-name": "Agrupar 61",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_58",
    "data-name": "Agrupar 58",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M280.947,368.869v79.417h12.68V368.869a121.725,121.725,0,0,0-36.038-86.494l-52.716-52.6v17.923l43.749,43.645A109.139,109.139,0,0,1,280.947,368.869Z",
    transform: "translate(-204.874 -155.485)",
    fill: "#edd47a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M327.437,393.2v107.31h12.681V393.2a121.739,121.739,0,0,0-36.038-86.5l-99.205-98.993v17.933l90.239,90.027A109.139,109.139,0,0,1,327.437,393.2Z",
    transform: "translate(-204.874 -207.708)",
    fill: "#edd47a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_57",
    "data-name": "Agrupar 57",
    transform: "translate(76.074 289.651)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_694",
    "data-name": "Ret\\xE2ngulo 694",
    width: 12.679,
    height: 531.508,
    fill: "#edd47a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_695",
    "data-name": "Ret\\xE2ngulo 695",
    width: 12.679,
    height: 640.396,
    transform: "translate(46.49 0)",
    fill: "#edd47a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftOrnament2);
export default __webpack_public_path__ + "static/media/left_ornament_2.ccb8a1904711f60d8461b39e7659f1e2.svg";
export { ForwardRef as ReactComponent };